export const APP_NAME = 'Đôi Bàn Tay Vàng - ZaloOA CMS'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const COMPANY_NAME = ""